import Draw, { DrawEvent } from 'ol/interaction/Draw';
import { useContext, useEffect, useState } from 'react'
import { MapContext } from '../MapContext'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import Text from 'ol/style/Text';
import { never } from 'ol/events/condition';
import { setDrawState } from '../../../../../state/features/drawStateSlice';
import { DrawStateType } from '../../../../../util/model/drawState';
import { useDispatch } from 'react-redux';
import { WKT } from 'ol/format';
import { setMapCoordinates } from '../../../../../state/features/coordinatesSlice';
import { getLength } from 'ol/sphere';
import { setButtonState } from '../../../../../state/features/buttonStateSlice';
import { ButtonState } from '../../../../shared/button-state/ButtonState';
import { MultiLineString } from 'ol/geom';
import { GeomDataHolder } from '../../../panorama-container/easy-pano-imports';
import { useAppSelector } from '../../../../../state/hooks';
import { setLon1,setLon2,setLat1,setLat2,setAltitude1,setAltitude2, setTimestamp, setIsMap } from '../../../../../state/features/roadProfileDataSlice';
import { RoadProfileRestApi } from '../../../../../util/restapi/roadProfile';


interface Props {
    source: any;
    onDrawComplete?: (feature: any) => void;
}

export const DrawLinestring = (props: Props) => {
    const map = useContext(MapContext);
    const dispatch = useDispatch();
    const [labeltext, setLabel] = useState<any>()
    const isMobileScreen: number = useAppSelector((state: any) => state.styleControl.isMobileScreen)

    const lon1 = useAppSelector((state) => state.roadProfileData.lon1);
    const lon2 = useAppSelector((state) => state.roadProfileData.lon2);
    const lat1 = useAppSelector((state) => state.roadProfileData.lat1);
    const lat2 = useAppSelector((state) => state.roadProfileData.lat2);
    const altitude1 = useAppSelector((state) => state.roadProfileData.altitude1);
    const altitude2 = useAppSelector((state) => state.roadProfileData.altitude2);
    const radius = useAppSelector((state) => state.roadProfileData.radius);
    const timestamp = useAppSelector((state) => state.roadProfileData.timestamp);
    const isMap = useAppSelector(state => state.roadProfileData.isMap);



// Inside your component where you need to call the API




    useEffect(() => {
        return ()=>{
            const intrsDraw :any = (window as any).olMap.getInteractions().getArray().find((interaction:any)=> interaction instanceof Draw)
            // console.log(intrsDraw);
    
            intrsDraw?.finishDrawing();
            if(isMobileScreen){
               
            }
           
        }
    }, []);

    useEffect(() => {
        let draw = new Draw({
            source: props.source,
            stopClick: true,
            type: 'LineString',
            style: new Style({
                stroke: new Stroke({
                    color: '#3ea1f1',
                    width: 3,
                }),
                fill: new Fill({
                    color: '#3ea1f1',
                }),
                image: new CircleStyle({
                    radius: 5,
                    fill: new Fill({
                        color: '#3ea1f1',
                    }),
                }),
            }),
            finishCondition: never,
            condition: function (e: any) {
                //sadece solla çizim yapıyor ve sağla bitiriyor
                if (e.originalEvent.buttons === 1) {
                    return true;
                } else if (e.originalEvent.buttons === 2) {
                    if (!labeltext) {
                        if(!((window as any).buttonState === ButtonState.ADD && (window as any).drawStartOfDigi)
                        && (window as any).buttonState !== ButtonState.EDIT){
                            dispatch(setButtonState(ButtonState.NONE));
                        }
                        dispatch(setDrawState({ drawStateType: DrawStateType.NONE }))
                    }
                    draw.finishDrawing();
                    return false;
                }
                else {
                    return false;
                }
            },

        });

        map.addInteraction(draw);

        draw.on('drawend', (event: any) => {
            const _geom = event.feature?.getGeometry().clone();
            const label = getLength(_geom)//.toFixed(2) + 'm';
            const timestamp = new Date().toISOString();
            const coordinates = _geom.transform('EPSG:3857', 'EPSG:4326').getCoordinates();

            // First point coordinates
            const startPoint = coordinates[0];
            dispatch(setLon1(startPoint[0]));
            dispatch(setLat1(startPoint[1]));
    
            // End point coordinates
            const endPoint = coordinates[coordinates.length - 1];
            dispatch(setLon2(endPoint[0]));
            dispatch(setLat2(endPoint[1]));
            
            // setting the altitude to be zero everytime for the map 2d

            dispatch(setAltitude1(0));
            dispatch(setAltitude1(0));

            dispatch(setTimestamp(timestamp));
/*             dispatch(setIsMap(true));
 */


            event.feature.setProperties({
                'timestamp': timestamp,
                'alias': 'draws'
            });

            setLabel(label)
            if (label) {
                let geom;
                const wkt = new WKT();
                const _geomClone: any = event.feature.getGeometry().clone()
                geom = new MultiLineString([_geomClone.transform('EPSG:3857', 'EPSG:4326').getCoordinates()]);
                const geomWktLine = wkt.writeGeometry(geom);
                geom.transform('EPSG:4326', 'EPSG:3857');
                const gdh: any = GeomDataHolder.fromWKT(geomWktLine);
                (window as any).panogl.getScalable().getMainSketchLayer().addGlobal(gdh);
                (window as any).panogl.getScalable().getMainSketchLayer().refresh();
                setTextAfterDrawEnd(event, gdh.attributes._length);
                (window as any).panogl.getScalable().getMainSketchLayer().removeFromGlobal(gdh);
                (window as any).panogl.getScalable().getMainSketchLayer().refresh();
                // setTextAfterDrawEnd(event, label)
            }

            if (props.onDrawComplete && (window as any).buttonState === ButtonState.ROAD_PROFILE) {
                props.onDrawComplete(event.feature);

            }

            dispatch(setDrawState({ drawStateType: DrawStateType.NONE }))
        });

        return () => {
            map.removeInteraction(draw)
        }

    }, [map])

    /**
     * Çizim bittikten sonra ölçüm değerini çizilen nesnenin üzerine yazar. 
     */
    const setTextAfterDrawEnd = (event: DrawEvent, length: any) => {
        const feature = event.feature;
        length = length//.toFixed(2);
        feature.setProperties({'alias': 'draws'})
        // console.log("drawss");
        
        feature.setStyle(new Style({
            stroke: new Stroke({
                color: '#3ea1f1',
                width: 3,
            }),
            fill: new Fill({
                color: '#3ea1f1',
            }),
            image: new CircleStyle({
                radius: 5,
                fill: new Fill({
                    color: '#3ea1f1',
                }),
            }),
            text: new Text({
                text: `${length}`,
                font: "bold 15px 'Open Sans', 'Arial Unicode MS', 'sans-serif'",
                placement: 'point',
                offsetY: -15,
                fill: new Fill({
                    color: 'white',
                }),
                stroke: new Stroke({
                    color: 'black',
                    width: 3,
                }),
            }),
        }));

        //aynı çizimi panorama üzerinde de göstermek için
        const wkt = new WKT();
        const wktFeature = wkt.writeFeature(feature)
        const result = {
            type: 'Point',
            feature: wktFeature,
            text: `${length}`
        }

        dispatch(setMapCoordinates(result))
    }

    return (
        <>
        </>
    )
}
